{
  "body.hello": "Hello,",
  "body.hello_name": "Hello {name},",
  "body.footer": "This message comes from Cargofollow. Replies to this message are not read.",
  "subject.sign_request": "Signature requested for shipment {reference}",
  "body.sign_request.intro": "{organization} asks you to sign the consignment note of shipment {reference} as {role}.",
  "body.sign_request.action": "Open this link to sign: {url}",
  "body.sign_request.expires": "The link stays valid until {expires} and works once.",
  "body.sign_request.ignore": "Do not recognise this request? You can ignore this message.",
  "sms.sign_request": "{organization}: sign the consignment note of shipment {reference}: {url}",
  "subject.otp": "Your Cargofollow verification code",
  "body.otp.intro": "Your verification code is {code}.",
  "body.otp.expires": "The code stays valid for {minutes} minutes and works once.",
  "body.otp.ignore": "Did you not ask for a code? Share it with nobody and ignore this message.",
  "sms.otp": "{code} is your Cargofollow verification code. Valid for {minutes} minutes; share it with nobody.",
  "subject.pod_delivered": "Proof of delivery available for shipment {reference}",
  "body.pod_delivered.intro": "Shipment {reference} was delivered on {delivered_at} and signed by {signer}.",
  "body.pod_delivered.remarks": "The consignee took over the goods under reservation.",
  "body.pod_delivered.no_remarks": "The goods were taken over without reservation.",
  "body.pod_delivered.action": "View the proof of delivery: {url}",
  "subject.authority_access": "An authority requested shipment {reference}",
  "body.authority_access.intro": "On {accessed_at} a competent authority retrieved the eFTI data of shipment {reference} through gate {gate}.",
  "body.authority_access.intro_no_gate": "On {accessed_at} a competent authority retrieved the eFTI data of shipment {reference}.",
  "body.authority_access.subsets": "Legal grounds invoked: {subsets}. Only the data belonging to those grounds was provided.",
  "body.authority_access.action": "Open the shipment and its full timeline: {url}",
  "body.authority_access.webhook": "You are getting this by e-mail because no webhook endpoint listens to efti.authority_access. Set one up to receive this notification straight into your own system.",
  "subject.invite": "Invitation to {organization} on Cargofollow",
  "body.invite.intro": "{inviter} invites you to join {organization} in the Cargofollow console as {role}.",
  "body.invite.action": "Open this link to accept the invitation: {url}",
  "body.invite.expires": "The invitation stays valid for 48 hours.",
  "body.invite.ignore": "Do not recognise this invitation? You can ignore this e-mail.",
  "subject.live_request": "Live request from {organization}",
  "body.live_request.intro": "{requester} ({email}) is requesting live access for {organization}.",
  "body.live_request.organization": "Organisation id: {id}",
  "body.live_request.note": "Note: {note}",
  "body.live_request.no_note": "No note was given.",
  "body.live_request.next": "Walk through the conformance checklist, then switch live_enabled on.",
  "role.owner": "owner",
  "role.admin": "admin",
  "role.developer": "developer",
  "role.viewer": "viewer",
  "role.consignor": "consignor",
  "role.carrier": "carrier",
  "role.consignee": "consignee",
  "sms.driver_otp": "{code} is your Cargofollow sign-in code. It is valid for {minutes} minutes. Do not share it with anyone."
}
